<span class="ic-arrow-up" *ngIf="isAscending"></span>
<span class="ic-arrow-down" *ngIf="isDescending"></span>